module.exports = __webpack_public_path__ + "static/media/faucet.248244e3.svg";